/* iArena product-page colour selector: siblings = products with the same title before " - ",
   found through predictive search. Hovering a dot previews that colour's photo over the gallery and keeps it
   selected; "Добави в количката" then adds the hovered colour in the chosen size. Click the same dot again
   (or the "Виж този цвят" link) to open that colour's page. */
(function () {
  var box = document.querySelector('.ar-pcolours');
  if (!box || !window.fetch) return;
  var base = (box.dataset.base || '').replace(/\s+/g, ' ').trim().toLowerCase();
  if (!base) return;
  var hex = {};
  try {
    var raw = JSON.parse((box.querySelector('[data-ar-hex]') || {}).textContent || '""') || '';
    raw.split('\n').forEach(function (l) { var kv = l.split('|'); if (kv.length >= 2) hex[kv[0].trim().toLowerCase()] = kv[kv.length - 1].trim(); });
  } catch (e) {}
  var dots = box.querySelector('.ar-pcolours__dots'), nameEl = box.querySelector('.ar-pcolours__name');
  var currentName = nameEl ? nameEl.textContent : '';
  var moneyZero = box.dataset.money || '€0,00';
  function money(p) {
    var n = Number(p); if (isNaN(n)) return '';
    var dec = moneyZero.indexOf('0,00') > -1 ? n.toFixed(2).replace('.', ',') : n.toFixed(2);
    return moneyZero.replace(/0[.,]00/, dec);
  }
  function colourOf(title) { var i = title.lastIndexOf(' - '); return i > -1 ? title.slice(i + 3).trim() : ''; }
  function styleFor(colour, img) {
    var c = colour.toLowerCase(), w = c.split(' ')[0];
    var h = hex[c] || hex[w];
    if (h) return 'background-color:' + h;
    if (img) return 'background-image:url(' + img.replace(/(\.[a-z]+)(\?|$)/i, '_80x$1$2') + ')';
    return 'background-color:#ddd';
  }

  // ---- add-to-cart wiring: the form of this product page
  var form = document.getElementById('product-form') || document.querySelector('form[action*="/cart/add"]');
  var btn = form && form.querySelector('.add_to_cart');
  var btnText = btn && btn.querySelector('.text');
  var baseLabel = btn ? (btn.getAttribute('data-label') || (btnText ? btnText.textContent : '')).trim() : '';
  function idField() { return form && form.querySelector('select[name="id"], input[name="id"]'); }
  function currentSize() {
    var f = idField(); if (!f) return '';
    if (f.tagName === 'SELECT') { var o = f.options[f.selectedIndex]; return o ? o.textContent.trim() : ''; }
    var pf = form.closest('.product_form'); return pf ? (pf.dataset.variantTitle || '').trim() : '';
  }
  function setLabel() {
    if (!btnText) return;
    btnText.textContent = pinned ? baseLabel + ' · ' + colourOf(pinned.title) : baseLabel;
  }
  function warn(msg) {
    document.querySelectorAll('.warning').forEach(function (w) { w.remove(); });
    var p = document.createElement('p'); p.className = 'warning animated bounceIn ar-cwarn'; p.textContent = msg;
    form.parentNode.insertBefore(p, form.nextSibling);
  }
  function variantsOf(p) {
    if (!p.vars) {
      var path = '/products/' + p.url.replace(/^https?:\/\/[^/]+/, '').split('/products/')[1].split('?')[0].split('/')[0];
      p.vars = fetch(path + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) { return j && j.variants ? j.variants : []; }).catch(function () { p.vars = null; return []; });
    }
    return p.vars;
  }
  var bypass = false;
  if (btn) {
    document.addEventListener('click', function (e) {
      var target = e.target.closest && e.target.closest('.add_to_cart, .ar-buy-now');
      if (bypass || !pinned || !target || !form.contains(target)) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var chosen = pinned, size = currentSize();
      variantsOf(chosen).then(function (vars) {
        if (pinned !== chosen) return;                                  // colour changed while loading
        var v = vars.filter(function (x) { return String(x.option1 || x.title).trim() === size; })[0];
        if (!v) { warn('Цвят ' + colourOf(chosen.title) + ' няма размер ' + size + '.'); return; }
        if (!v.available) { warn('Цвят ' + colourOf(chosen.title) + ' в размер ' + size + ' е изчерпан.'); return; }
        var f = idField(); if (!f) return;
        var temp = null, prev = f.value;
        if (f.tagName === 'SELECT') {
          temp = document.createElement('option'); temp.value = String(v.id); temp.textContent = size; f.appendChild(temp); f.value = String(v.id);
        } else { f.value = String(v.id); }
        bypass = true;
        try { target.click(); } finally { bypass = false; }             // the theme's ajax handler / Buy-now script serialises the form now
        setTimeout(function () { if (temp) temp.remove(); f.value = prev; }, 0);
        [1500, 2500, 4000].forEach(function (t) { setTimeout(setLabel, t); }); // theme resets the label after its "added" flash
      });
    }, true);
  }

  // ---- preview overlay in the gallery
  var gallery = document.querySelector('.product-gallery__main') || document.querySelector('.product__images, .product-gallery');
  var overlay = null, pinned = null, pinnedBy = '';
  function showPreview(p) {
    if (!gallery) return;
    if (!overlay) {
      overlay = document.createElement('div'); overlay.className = 'ar-preview';
      overlay.innerHTML = '<img class="ar-preview__img" alt=""><div class="ar-preview__bar"><span class="ar-preview__cap"></span><a class="ar-preview__go" href="#"></a><button type="button" class="ar-preview__close" aria-label="Затвори">×</button></div>';
      gallery.appendChild(overlay);
      overlay.querySelector('.ar-preview__close').addEventListener('click', function () { unpin(); });
    }
    var img = overlay.querySelector('.ar-preview__img');
    img.src = p.img ? p.img.replace(/(\.[a-z]+)(\?|$)/i, '_1200x$1$2') : '';
    img.alt = p.title;
    overlay.querySelector('.ar-preview__cap').textContent = colourOf(p.title) + (p.price ? ' · ' + money(p.price) : '') + (p.available ? '' : ' · изчерпан');
    var go = overlay.querySelector('.ar-preview__go'); go.href = p.url; go.textContent = (box.dataset.go || 'Виж този цвят') + ' →';
    overlay.classList.add('is-on');
    if (nameEl) nameEl.textContent = colourOf(p.title);
  }
  function hidePreview() {
    if (overlay) overlay.classList.remove('is-on');
    if (nameEl) nameEl.textContent = currentName;
    if (!pinned) dots.querySelectorAll('.ar-dot').forEach(function (d) { d.classList.toggle('ar-dot--current', !d.dataset.url); d.classList.remove('is-preview'); });
    setLabel();
  }
  function pin(a, data, by) {
    pinned = data; pinnedBy = by;
    dots.querySelectorAll('.ar-dot').forEach(function (d) { d.classList.remove('ar-dot--current', 'is-preview'); });
    a.classList.add('ar-dot--current', 'is-preview');
    showPreview(data); setLabel(); variantsOf(data);
  }
  function unpin() { pinned = null; pinnedBy = ''; hidePreview(); }

  var url = '/search/suggest.json?q=' + encodeURIComponent(box.dataset.base) + '&resources[type]=product&resources[limit]=10&resources[options][fields]=title&resources[options][unavailable_products]=last';
  fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
    if (!j || !j.resources || !j.resources.results) return;
    var sib = (j.resources.results.products || []).filter(function (p) {
      var i = p.title.lastIndexOf(' - '); if (i < 0) return false;
      return p.title.slice(0, i).replace(/\s+/g, ' ').trim().toLowerCase() === base && p.handle !== box.dataset.handle;
    });
    if (!sib.length) return;
    sib.forEach(function (p) {
      var a = document.createElement('a');
      a.className = 'ar-dot' + (p.available ? '' : ' ar-dot--out');
      a.href = p.url.split('?')[0]; a.dataset.url = a.href; a.title = colourOf(p.title) + (p.available ? '' : ' (изчерпан)');
      a.setAttribute('style', styleFor(colourOf(p.title), p.featured_image && p.featured_image.url));
      var data = { title: p.title, url: a.href, img: p.featured_image && p.featured_image.url, price: p.price, available: p.available };
      // hover = this colour becomes the selected one (photo preview + add-to-cart target); it stays until another dot is hovered
      a.addEventListener('mouseenter', function () { pin(a, data, 'hover'); });
      a.addEventListener('click', function (e) {
        if (pinned === data && pinnedBy === 'click') return;            // second click = go to that product
        e.preventDefault();
        pin(a, data, 'click');
      });
      dots.appendChild(a);
    });
    var cur = dots.querySelector('.ar-dot:not([data-url])');
    if (cur) {
      cur.addEventListener('click', function () { unpin(); });
      cur.addEventListener('mouseenter', function () { unpin(); });
    }
    dots.addEventListener('mouseleave', function () { if (pinned) showPreview(pinned); else hidePreview(); });
    box.classList.add('is-ready');
  }).catch(function () {});
})();
